import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../scripts/control';
import '../../css/BdStyles.css';


const BdMovieDetail = () => {
    const { idMovie } = useParams();
    const { idMovieTag } = useParams();
    const navigate = useNavigate();
    const [movie, setMovie] = useState(null);
    const [tag, setTag] = useState(null);
    const [selectedTag, setSelectedTag] = useState(null); 
    const [tagDetails, setTagDetails] = useState(null); 
    const [showModal, setShowModal] = useState(false); 
    const [credits, setCredits] = useState([{ label: '', value: '' }]);
    const [articles, setArticles] = useState([{ label: '', value: '' }]);

    useEffect(() => {
        const fetchMovies = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?idMovie=${idMovie}`);
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                const data = await response.json();
    
                // Asegurar que data.tags sea un array
                const tags = Array.isArray(data.tags) ? data.tags : [];
    
                // Asegurarse de que data.movies existe y es un array
                const movies = data.movies || [];
                const foundMovie = movies[0] || null;
    
                if (foundMovie) {
                    // Convertir foundMovie.tags a un array si es un string
                    if (typeof foundMovie.tags === 'string') {
                        foundMovie.tags = foundMovie.tags
                            .split(', ')
                            .map(tag => tag.trim());
                    } else if (!Array.isArray(foundMovie.tags)) {
                        foundMovie.tags = [];
                    }

                    if (foundMovie.credits) {
                        const creditsArray = foundMovie.credits.split('||').map(item => {
                            const parts = item.split('::');
                            return parts.length === 2 ? { credit_label: parts[0], credit_value: parts[1] } : null;
                        }).filter(item => item !== null);
                        foundMovie.credits = creditsArray;
                        setCredits(creditsArray);  // Actualizamos el estado de créditos
                    } else {
                        foundMovie.credits = [];
                        setCredits([]);
                    }

                    if (foundMovie.articles) {
                        const articlesArray = foundMovie.articles.split('||').map(item => {
                            const parts = item.split('::');
                            return parts.length === 2 ? { articleLabel: parts[0], articleDetail: parts[1] } : null;
                        }).filter(item => item !== null);
                        foundMovie.articles = articlesArray;
                        setArticles(articlesArray);  // Actualizamos el estado de créditos
                    } else {
                        foundMovie.articles = [];
                        setArticles([]);
                    }
    
                    // Construir un objeto para los detalles de etiquetas usando los id y nombres de tags
                    const tagDetailsByName = {};
                    tags.forEach(tag => {
                        if (foundMovie.tagsDetails && foundMovie.tagsDetails[tag.idTag]) {
                            tagDetailsByName[tag.tagName] = foundMovie.tagsDetails[tag.idTag];
                        }
                    });
    
                    foundMovie.tagsDetails = tagDetailsByName;
                    setMovie(foundMovie);
                } else {
                    setMovie(null);
                }
            } catch (error) {
                setMovie(null);
            }
        };
    
        fetchMovies();
    }, [idMovie]);


    useEffect(() => {
    const fetchTags = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/BdMovies_func.php?fetchTags=true`);
                const data = await response.json();
                const tags = Array.isArray(data.tags) ? data.tags : [];
            
                // Filtrar la película específica por `idMovieTag` en el frontend
                const foundTag = tags.find(tag => tag.idTag === idMovieTag); 
            
            setTag(foundTag || null);
            } catch (error) {
            }
        };
        fetchTags();
    }, [idMovieTag]);

    const handleTagClick = (clickedTag) => {
        // Obtener los detalles de la etiqueta desde el objeto tagsDetails
        const tagDetail = movie.tagsDetails[clickedTag] || "No hay detalles disponibles para esta etiqueta.";
    
        setSelectedTag(clickedTag);
        setTagDetails(tagDetail);
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setTagDetails(null);
    };

    if (!movie) {
        return <div>Cargando detalles...</div>;
    }
    
    return (
        <div className="bd">
        <div className="container">
            <button className="btn btn-secondary mb-3" onClick={() => navigate(-1)}>
                Volver
            </button>
            <div className="card">
                <img
                    src={`${API_BASE_URL}/public/uploads/images/${movie.img_url}`}
                    alt={movie.movieName}
                    className="card-img-top"
                    loading="lazy"
                />
                <div className="card-body">
                    <h2>{movie.movieName}</h2>
                    <p><strong>Año:</strong> {movie.movieYear}</p>
                    <p><strong>Clasificación:</strong> {movie.movieAge}</p>
                    <p><strong>Duración:</strong> {movie.movieDuration} minutos</p>              
                    <p>
                      <strong>Sinopsis:</strong> {movie.synopsis}
                    </p>
                    <p>
                      <strong>Estructura:</strong> {movie.structure}
                    </p>
                    <p><strong>Etiquetas:</strong></p>
                    <div>
                        {movie.tags?.map((tag, index) => (
                        <button
                            key={index}
                            className="btn btn-outline-primary me-2 mb-2"
                            onClick={() => handleTagClick(tag)}
                        >
                            {tag}
                        </button>
                    ))}
                    </div>
                    <br></br>
                    { credits?.length > 0 && (
                    <div className="movie-credits">
                      <h3>Créditos</h3>
                      <ul>
                        {credits.map((credit, index) => (
                          <li key={index} className="credit-item">
                            <span className="credit-label">{credit.credit_label}:</span>{" "}
                            <span className="credit-value">{credit.credit_value}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                    )}
                    { articles?.length > 0 && (
                    <div className="articles-container">
                    <h3>Artículos relacionados</h3>
                      {articles.map((article, index) => (
                        <div key={index} className="article-card">
                          <p className="article-label">{article.articleLabel}</p>
                          <p className="article-detail">{article.articleDetail}</p>
                        </div>
                      ))}
                    </div>
                    )}
                </div>
            </div>
            {/* Modal */}
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">{selectedTag} en {movie.movieName}</h5>
                                <button type="button" className="btn-close" onClick={closeModal}></button>
                            </div>
                            <div className="modal-body">
                                {tagDetails ? (
                                    <p>{tagDetails}</p>
                                ) : (
                                    <p>Cargando detalles de la etiqueta...</p>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal}>
                                    Cerrar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    </div>
    );
};

export default BdMovieDetail;
